import { FC, useEffect, useState } from 'react';
import styled from './index.module.scss';
import Banner from './Banner';
import Refer from '@/components/Referral/Common/Refer';
import Terms from '@/components/Referral/Common/Terms';
import Subscribe from '@/components/Referral/Common/SubscribeReceive';
import ProductGallery from '@/components/Referral/Share/ProductGallery';
import Rewards from '@/components/Referral/Receive/Rewards';
import Products from '@/components/Referral/Receive/Products';
import Benefits from '@/components/Referral/Receive/Benefits';
import JoinUs from '@/components/Referral/Receive/JoinUs';
import CallToActionBanner from '@/components/Referral/Receive/CallToActionBanner';
import BenefitsNew from '@/components/EcoCredits/BenefitsNew';
import { useReferralDispatch, useReferralStore } from '@/components/Referral/ReferralProvider';
import Button from '@/components/UI/Button';
import EfModal from '@/components/UI/Modal';
import { useGlobal } from '@/utils/useGlobal';
import { checkInviteCode } from '@/service/referral';
import { message } from '@/components/UI';
import { loginUser } from '@/utils/cookie';
import getLocal from '@/app/utils/getLocal';
import { getRewardRuleList, getRewardUserLevel } from '@/service/vip';
import { useMonthlyDispatch } from '@/components/EcocreditsMonthlyMadness/MonthlyProvider';

const MemberFestivalReferral: FC<{ isLogin: boolean }> = ({ isLogin }) => {
    const { useLang, useRouter, Link } = useGlobal();
    const router = useRouter();
    const { locale, pathname } = getLocal();
    const { t } = useLang('referral');
    const dispatch = useReferralDispatch();
    const monthlyDispatch = useMonthlyDispatch();
    const { inBlackList, actStatus, pageUsing, referralInfo } = useReferralStore();
    const [codeState, setCodeState] = useState('0');
    const [userInfo, setUserInfo] = useState<any>({});
    const [show, setShow] = useState(false);
    const registerUrl = `/${locale}/register?inviteCode=${router.query.inviteCode}&redirect=${encodeURIComponent(`/${locale}${router.asPath}`)}`;

    const inviteErrorMap: Record<string, string> = {
        '2430': t('active_is_unstart'),
        '2431': t('active_is_ended'),
        '2438': t('invitation_expired'),
        '2439': t('invitation_ip'),
    };

    const isActivityWithNA = ['us', 'ca'].includes(locale) && actStatus === 1;

    // us/ca 活动期间文案修改，desc修改
    const getBannerText = () => {
        if (isActivityWithNA) return t('banner.desc2_1');
        return t('banner.desc2');
    };

    const getBannerTitle = () => {
        if (['us', 'ca'].includes(locale) && actStatus === 1) return t('banner.title_1');
        return t('banner.title');
    };

    useEffect(() => {
        let pageType = '';
        const { inviteCode } = router.query;
        if (pathname === '/referral-rewards-delta-pro-3-portable-power-station') {
            pageType = 'dp3';
        }
        dispatch({ type: 'changePageUsingInfo', payload: pageType });
        dispatch({ type: 'getReferralInfoByInviteCode', payload: { locale, inviteCode } });
        checkCodeState();
        queryRewardUserLevel();
        setUserInfo(loginUser());
    }, []);

    // 检查 inviteCode 状态
    const checkCodeState = async () => {
        const { inviteCode } = router.query;
        // 如果没有邀请码 直接跳转分享页
        if (!inviteCode) {
            router.push('/referral');
            return;
        }
        // const fp = await FingerprintJS.load();
        // const { visitorId } = await fp.get();
        const res = await checkInviteCode({ inviteCode }, locale);
        if (res.code !== '0') {
            setCodeState(res.code);
            inviteErrorMap[res.code] && message.error(inviteErrorMap[res.code]);
            if (res.code === '2439' || res.code === '2438') {
                router.push('/404');
            }
            if (res.code === '2440') {
                router.push('/referral');
            }
        }
    };

    /**
     * 查询账户权益等级
     */
    const queryRewardUserLevel = async () => {
        const ruleRes = await getRewardRuleList(locale as string);
        if (ruleRes?.code !== '0') return;
        const plusMemberData = ruleRes.data.find((item) => item.level === 2);
        const memberData = ruleRes.data.find((item) => item.level === 1);
        const payload = {
            normalName: memberData?.name,
            plusName: plusMemberData?.name,
            minPoint: Number(plusMemberData?.minPoints),
        };

        if (isLogin) {
            const levelRes = await getRewardUserLevel(locale as string);
            if (levelRes?.code === '0' && levelRes.data) {
                const { level, validStartTime, validEndTime } = levelRes.data;
                const userLevelData = ruleRes.data.find((item) => item.level === level);

                Object.assign(payload, {
                    level,
                    validStartTime,
                    validEndTime,
                    name: userLevelData?.name || '',
                });
            }
        }
        monthlyDispatch({
            type: 'changeRewardUserLevel',
            payload,
        });
    };

    const toRegisterPage = async () => {
        if (actStatus === 1) {
            location.href = `/${locale}/register?inviteCode=${router.query.inviteCode}&redirect=${encodeURIComponent(
                `https://${locale}.ecoflow.com/pages/prime-day`,
            )}`;
            return;
        }
        if (codeState === '2442') setShow(true);
        if (codeState !== '0') return;
        location.href = registerUrl;
    };

    useEffect(() => {
        console.log(referralInfo);
    }, [referralInfo]);

    return (
        <>
            <style jsx global>
                {`
                    .ant-message {
                        z-index: 9999999;
                    }
                    .ant-modal-root {
                        z-index: 2102;
                    }
                `}
            </style>
            <div className={`${styled.receive_compoment}`}>
                <Banner
                    title={
                        isLogin
                            ? t.rich('banner.title2', {
                                  name: () => userInfo?.user?.name || userInfo?.user?.email,
                              })
                            : getBannerTitle()
                    }
                    desc={
                        isLogin
                            ? getBannerText()
                            : isActivityWithNA
                            ? t('banner.desc_1')
                            : t.rich('banner.desc', {
                                  line1: (text: string) => (
                                      <a className="register_text" onClick={toRegisterPage}>
                                          {text}
                                      </a>
                                  ),
                              })
                    }
                    isInner={false}
                >
                    {!isLogin && (
                        <Button className="refer-btn" onClick={toRegisterPage} disabled={inBlackList}>
                            {t('banner.btn')}
                        </Button>
                    )}
                </Banner>
                <CallToActionBanner />
                {pageUsing !== undefined && pageUsing !== 'dp3' && (
                    <>
                        {isLogin && <Rewards planId={referralInfo?.planId} />}
                        {/* {referralInfo?.planType === PlanType.CAMPAIGN && (
                            <MemberCard title={t('member.title')} subTitle={t('member.subTitle')} cta={t('member.button')} />
                        )} */}
                        {/* <Blogs subScribe={() => subRef.current?.handleOpen()} /> */}
                        {/* <Benefits /> */}
                        <BenefitsNew />
                        <Products />
                        {isLogin && <Refer isShare={false} shareUrl={`/${locale}/members-festival#referral`} />}
                        {isLogin && <JoinUs />}
                        <Terms />
                        <Subscribe isShare={true} />
                    </>
                )}
                {pageUsing !== undefined && pageUsing === 'dp3' && (
                    <>
                        {isLogin && <Rewards planId={referralInfo?.planId} />}
                        <ProductGallery />
                        <Products type="dp3" />
                        <Benefits />
                        {isLogin && <Refer isShare={false} />}
                        {isLogin && <JoinUs />}
                        <Terms />
                    </>
                )}

                <EfModal
                    width="560"
                    visible={show}
                    open={show}
                    className={`${styled.no_active_modal}`}
                    centered={true}
                    getContainer={true}
                    onCancel={() => setShow(false)}
                >
                    <div className="content">
                        <h5 className="title">{t('invitation_tips_title')}</h5>
                        <p className="msg">{t('invitation_tips_cotent')}</p>
                        <div className="tools">
                            <Button className="btn later" onClick={() => setShow(false)}>
                                {t('invitation_tips_cancel')}
                            </Button>
                            <Link href={registerUrl}>
                                <Button className="btn">{t('invitation_tips_confirm')}</Button>
                            </Link>
                        </div>
                    </div>
                </EfModal>
            </div>
        </>
    );
};

export default MemberFestivalReferral;
